import { call, put, all, fork, takeEvery, select } from 'redux-saga/effects'

import { showLoading, hideLoading } from 'react-redux-loading-bar'

import DeliveryAreasService from '../middlewares/deliveryAreas'

import {
  GET_DELIVERY_AREAS,
  GET_DELIVERY_AREAS_REQUEST,
  GET_DELIVERY_AREAS_REQUEST_ERROR,
  GET_DELIVERY_AREAS_REQUEST_PENDING,
  GET_DELIVERY_AREAS_REQUEST_SUCCESS,
  PULL_DELIVERY_AREAS_REQUEST,
  UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST,
} from '../types/deliveryAreas'

function* getDeliveryAreasWatcher() {
  yield takeEvery(GET_DELIVERY_AREAS_REQUEST, getDeliveryAreasWorker)
}

function* pullDeliveryAreasWatcher() {
  yield takeEvery(PULL_DELIVERY_AREAS_REQUEST, pullDeliveryAreasWorker)
}

function* updateAreaGovernorateWatcher() {
  yield takeEvery(UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST, updateAreaGovernorateWorker)
}

function* getDeliveryAreasWorker({ payload: { page, size, search } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_PENDING })
    const response = yield call(DeliveryAreasService.getDeliveryAreas, page, size, search)
    const { result, total } = response.data.data
    yield put({
      type: GET_DELIVERY_AREAS,
      payload: {
        items: result,
        pagination: {
          current: page,
          pageSize: size,
          total: total,
        },
      },
    })
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_DELIVERY_AREAS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* pullDeliveryAreasWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_PENDING })
    yield call(DeliveryAreasService.pullDeliveryAreas)
    const { current, pageSize } = yield select((state) => state.deliveryAreas.pagination)
    yield put({
      type: GET_DELIVERY_AREAS_REQUEST,
      payload: {
        page: current,
        size: pageSize,
      },
    })
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_DELIVERY_AREAS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* updateAreaGovernorateWorker({ payload: { id, governorateId } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_PENDING })
    yield call(DeliveryAreasService.updateAreaGovernorate, id, governorateId)
    const { current, pageSize } = yield select((state) => state.deliveryAreas.pagination)
    yield put({
      type: GET_DELIVERY_AREAS_REQUEST,
      payload: {
        page: current,
        size: pageSize,
      },
    })
    yield put({ type: GET_DELIVERY_AREAS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_DELIVERY_AREAS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

export default function* deliveryAreas() {
  yield all([fork(getDeliveryAreasWatcher), fork(pullDeliveryAreasWatcher), fork(updateAreaGovernorateWatcher)])
}

